module.exports = __webpack_public_path__ + "static/media/5.c769de5d.jpg";